export const LIVE_PRICE = "292,50KM sa uključenim PDV-om";
export const ONLINE_PRICE = "169,65KM sa uključenim PDV-om";
